import {Graph} from '@antv/x6';
import {ARCHIMATE_PICTO_ICON_CORNER, MIN_GROUP_ELEMENT_HEIGHT} from '../modelerX6/constants';
import {FULL_ELEMENT_MAP, JUNCTION, AND_JUNCTION, OR_JUNCTION, NOTE} from '../util/ModelUtil';

export function registerArchimateShapes() {
	if (globalThis.__archimateX6ShapesRegistered) {
		return;
	}

	const toKebabCase = value =>
		String(value)
			.replace(/([a-z0-9])([A-Z])/g, '$1-$2')
			.replace(/\s+/g, '-')
			.toLowerCase();

	const registerElementNode = (shape, label) => {
		Graph.registerNode(
			shape,
			{
				inherit: 'rect',
				width: 120,
				height: 55,
				markup: [
					{tagName: 'rect', selector: 'body'},
					{tagName: 'path', selector: 'icon'},
					{tagName: 'text', selector: 'label'},
				],
				attrs: {
					body: {
						fill: '#ffffff',
						stroke: '#000000',
						strokeWidth: 1,
					},
					icon: {
						d: '',
						fill: '#ffffff',
						stroke: '#000000',
						strokeWidth: 0.8,
					},
					label: {
						text: label,
						fontSize: 12,
						fill: '#000000',
						refX: 8,
						refY: 0.5,
						refWidth: 0.62,
						textAnchor: 'start',
						textVerticalAnchor: 'middle',
						textWrap: {width: '100%', height: '100%', ellipsis: true},
					},
				},
			},
			true
		);
	};

	// Junction: маленький кружок; подпись — фигура Label сверху от круга.
	// inner — белая заливка центра (для And Junction кольцо без заливки, перетаскивать можно и за центр).
	const registerCircleNode = (shape, defaultLabel) => {
		Graph.registerNode(
			shape,
			{
				inherit: 'circle',
				width: 20,
				height: 20,
				markup: [
					{tagName: 'circle', selector: 'inner'},
					{tagName: 'circle', selector: 'body'},
					{tagName: 'rect', selector: 'labelBody'},
					{tagName: 'text', selector: 'label'},
				],
				attrs: {
					inner: {
						refCx: '50%',
						refCy: '50%',
						refR: '50%',
						fill: '#ffffff',
						stroke: 'none',
					},
					body: {
						fill: '#ffffff',
						stroke: '#000000',
						strokeWidth: 1,
					},
					labelBody: {
						ref: 'label',
						fill: '#fff',
						rx: 3,
						ry: 3,
						refWidth: 1,
						refHeight: 1,
						refX: 0,
						refY: 0,
					},
					label: {
						text: defaultLabel,
						fontSize: 10,
						fill: '#000000',
						refX: 10,
						refY: -8,
						textAnchor: 'middle',
						textVerticalAnchor: 'middle',
					},
				},
			},
			true
		);
	};

	registerCircleNode('archimate:and-junction', 'AndJunction');
	registerCircleNode('archimate:or-junction', 'OrJunction');

	const registerNoteNode = (shape, label) => {
		Graph.registerNode(
			shape,
			{
				inherit: 'rect',
				width: 120,
				height: 55,
				markup: [
					{tagName: 'path', selector: 'body'},
					{tagName: 'text', selector: 'label'},
				],
				attrs: {
					body: {
						d: '',
						fill: '#ffffff',
						stroke: 'rgba(0,0,0,0.4)',
						strokeWidth: 1,
					},
					label: {
						text: label,
						fontSize: 12,
						fill: '#000000',
						refX: 8,
						refY: 8,
						refWidth: -16,
						refHeight: -16,
						textAnchor: 'start',
						textVerticalAnchor: 'top',
						textWrap: {width: '100%', height: '100%', ellipsis: true},
					},
				},
			},
			true
		);
	};

	registerNoteNode('archimate:label', 'Note');

	Graph.registerNode(
		'canvas:sticker',
		{
			inherit: 'rect',
			width: 150,
			height: 150,
			markup: [
				{tagName: 'rect', selector: 'shadow'},
				{tagName: 'rect', selector: 'body'},
				{tagName: 'text', selector: 'label'},
			],
			attrs: {
				shadow: {
					refWidth: '100%',
					refHeight: '100%',
					x: 2,
					y: 3,
					rx: 3,
					ry: 3,
					fill: 'rgba(0,0,0,0.16)',
					stroke: 'none',
				},
				body: {
					fill: '#FFF9B1',
					stroke: 'none',
					strokeWidth: 0,
					rx: 3,
					ry: 3,
					magnet: false,
				},
				label: {
					text: '',
					fontSize: 13,
					fill: '#333333',
					refX: 0.5,
					refY: 0.5,
					textAnchor: 'middle',
					textVerticalAnchor: 'middle',
					textWrap: {width: -20, height: -20, ellipsis: true, breakWord: true},
				},
			},
		},
		true
	);

	const registerGroupNode = (shape, defaultLabel) => {
		Graph.registerNode(
			shape,
			{
				inherit: 'rect',
				width: 120,
				height: MIN_GROUP_ELEMENT_HEIGHT,
				markup: [
					{tagName: 'path', selector: 'body'},
					{tagName: 'text', selector: 'label'},
				],
				attrs: {
					body: {
						d: '',
						fill: '#c0c0c0',
						stroke: '#585858',
						strokeWidth: 1,
					},
					label: {
						text: defaultLabel,
						fontSize: 12,
						fill: '#000000',
						refX: 8,
						refY: 8,
						refWidth: 0.84,
						refHeight: 0.84,
						textAnchor: 'start',
						textVerticalAnchor: 'top',
						textWrap: {width: '100%', height: '100%', ellipsis: true},
					},
				},
			},
			true
		);
	};
	registerGroupNode('archimate:group', '');

	// Элементы Motivation — шестиугольник (body path задаётся в _buildElementNodeConfig)
	const registerHexagonElementNode = shape => {
		Graph.registerNode(
			shape,
			{
				inherit: 'rect',
				width: 120,
				height: 55,
				markup: [
					{tagName: 'path', selector: 'body'},
					{tagName: 'path', selector: 'icon'},
					{tagName: 'text', selector: 'label'},
				],
				attrs: {
					body: {d: '', fill: '#ffffff', stroke: '#000000', strokeWidth: 1},
					icon: {
						d: '',
						fill: '#ffffff',
						stroke: '#000000',
						strokeWidth: 0.8,
						refX: 0.78,
						refY: 0,
					},
					label: {
						text: '',
						fontSize: 12,
						fill: '#000000',
						refX: 8,
						refY: 0.5,
						refWidth: 0.65,
						textAnchor: 'start',
						textVerticalAnchor: 'middle',
						textWrap: {width: '100%', height: '100%', ellipsis: true},
					},
				},
			},
			true
		);
	};
	registerHexagonElementNode('archimate:element-hexagon');

	// Grouping — форма с вкладкой (body path задаётся в _buildElementNodeConfig)
	const registerGroupingNode = shape => {
		Graph.registerNode(
			shape,
			{
				inherit: 'rect',
				width: 120,
				height: MIN_GROUP_ELEMENT_HEIGHT,
				markup: [
					{tagName: 'path', selector: 'body'},
					{tagName: 'path', selector: 'icon'},
					{tagName: 'text', selector: 'label'},
				],
				attrs: {
					body: {d: '', fill: '#ffffff', stroke: '#000000', strokeWidth: 1},
					icon: {
						d: '',
						fill: '#000000',
						stroke: '#ffffff',
						strokeWidth: 0.5,
						...ARCHIMATE_PICTO_ICON_CORNER,
					},
					label: {
						text: '',
						fontSize: 12,
						fill: '#000000',
						refX: 8,
						refY: 8,
						refWidth: 0.65,
						textAnchor: 'start',
						textVerticalAnchor: 'top',
						textWrap: {width: '100%', height: '100%', ellipsis: true},
					},
				},
			},
			true
		);
	};
	registerGroupingNode('archimate:grouping');

	for (const [type, entry] of FULL_ELEMENT_MAP.entries()) {
		if (!entry || !(entry.pictoRef || entry.pathMap || entry.figureRef)) {
			continue;
		}
		if (type === JUNCTION || type === AND_JUNCTION || type === OR_JUNCTION || type === NOTE) {
			continue;
		}

		const shape = `archimate:${toKebabCase(type)}`;
		registerElementNode(shape, entry.typeName || type);
	}

	globalThis.__archimateX6ShapesRegistered = true;
}
